import { CallForActionButton, CallForActionButtonTooltip } from 'components/buttons/CallForActionButton';
import { t } from 'utils/getTranslations';
import TrackingGlyph from './TrackingGlyph';

type Props = {
    onClick: () => void;
    disabled?: boolean;
    /** Whether it took the other button's place, which its glyph then cross-fades from. */
    swapped?: boolean;
};

const PauseTrackingIconButton = ({ onClick, disabled, swapped }: Props): JSX.Element => {
    return (
        <CallForActionButtonTooltip title={t('timecards.pause')}>
            <CallForActionButton
                variant="contained"
                color="secondary"
                shape="rounded"
                aria-label={t('timecards.pause')}
                disabled={disabled}
                className="bg-secondary text-primary-foreground"
                onClick={onClick}
            >
                <TrackingGlyph tracking swapped={swapped} />
            </CallForActionButton>
        </CallForActionButtonTooltip>
    );
};

export default PauseTrackingIconButton;
